// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "../../../common/util.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "@rescript/std/lib/es6/js_dict.js";
import * as Segment from "../../../bindings/Segment.bs.js";
import * as SmartLink from "../../library/SmartLink.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as SignUpSteps from "./steps/SignUpSteps.bs.js";
import * as Router from "next/router";
import * as SignUpForName from "./steps/SignUpForName.bs.js";
import * as SignUpForEmail from "./steps/SignUpForEmail.bs.js";
import * as LayoutDataContext from "../../../utils/LayoutDataContext.bs.js";
import * as OnboardingReducer from "../../../utils/OnboardingReducer.bs.js";
import * as ProgressIndicator from "./steps/ProgressIndicator.bs.js";
import * as SignUpForPassword from "./steps/SignUpForPassword.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as SignUpSecurityCode from "./steps/SignUpSecurityCode.bs.js";
import * as SignUpForPhoneNumber from "./steps/SignUpForPhoneNumber.bs.js";
import * as Kontent$PrezzeeRibbon from "@prezzee/ribbon/src/components/personal/Kontent/Kontent.bs.js";
import * as KontentContextProvider from "../index/KontentContextProvider.bs.js";
import * as ProductPageSegmentHook from "../../../utils/ProductPageSegmentHook.bs.js";
import * as SignUpOnboardingStyles from "./SignUpOnboardingStyles.bs.js";

function RegisterComponent(props) {
  var purchaseCallback = props.purchaseCallback;
  var layoutData = LayoutDataContext.useContext(undefined);
  var registerData = Belt_Option.flatMap(layoutData, (function (o) {
          return o.register;
        }));
  var match = OnboardingReducer.useOnboardingReducer(undefined);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        return /* CaptureNames */0;
      });
  var setStep = match$1[1];
  var step = match$1[0];
  var router = Router.useRouter();
  var path = router.asPath;
  var refQueryOpt = Js_dict.get(router.query, "ref");
  var signupTypeFromRefQuery = refQueryOpt === "store" ? /* DuringPurchase */1 : /* SignupPage */4;
  var deduceRegistrationFlowSignupType = function (signupType, signupTypeFromRefQuery) {
    if (signupType !== 0) {
      if (signupTypeFromRefQuery !== 1) {
        return /* SignupPage */4;
      } else {
        return /* DuringPurchase */1;
      }
    } else {
      return /* GiftOpen */0;
    }
  };
  var registrationFlowSignupType = deduceRegistrationFlowSignupType(props.signupType, signupTypeFromRefQuery);
  var registrationFlowSignupTypeString = Segment.Registration.getSignupTypeAsString(registrationFlowSignupType);
  var segmentUuid = React.useRef(ProductPageSegmentHook.generateUniqueUserId(undefined));
  var segmentData_signup_instance_id = segmentUuid.current;
  var segmentData = {
    signup_instance_id: segmentData_signup_instance_id,
    path: path
  };
  var title_ = Belt_Option.mapWithDefault(registerData, "Sign up to Prezzee", (function (c) {
          return c.title;
        }));
  var subtitle_ = Belt_Option.flatMap(registerData, (function (c) {
          return c.subtitle;
        }));
  var match$2 = Belt_Option.mapWithDefault(registerData, SmartLink.emptySmartLink, (function (c) {
          return c.smartLink;
        }));
  var handlePreviousBtnClick = function (param) {
    Curry._1(setStep, (function (param) {
            return SignUpSteps.getPrevStep(step);
          }));
  };
  var makeSegmentCallData = function (element) {
    return Segment.Registration.makeBaseData(element, segmentUuid.current, path, registrationFlowSignupTypeString);
  };
  var makeSegmentCall = function (param) {
    switch (step) {
      case /* CaptureNames */0 :
          return ;
      case /* CaptureEmail */1 :
          return Segment.customElementInteraction(makeSegmentCallData("sign_up_first_last_name"));
      case /* CapturePassword */2 :
          return Segment.customElementInteraction(makeSegmentCallData("sign_up_email"));
      case /* CapturePhoneNumber */3 :
          return Segment.customElementInteraction(makeSegmentCallData("sign_up_password"));
      case /* ConfirmSecurityCode */4 :
          return Segment.customElementInteraction(makeSegmentCallData("sign_up_mobile_verification"));
      
    }
  };
  var handleNextBtnClick = function (param) {
    Curry._1(setStep, (function (param) {
            return SignUpSteps.getNextStep(step);
          }));
  };
  React.useEffect((function () {
          makeSegmentCall(undefined);
        }), [step]);
  var tmp;
  switch (step) {
    case /* CaptureNames */0 :
        tmp = JsxRuntime.jsx(SignUpForName.make, {
              stateFirstName: state.firstName,
              stateLastName: state.lastName,
              dispatch: dispatch,
              onNextBtnClick: handleNextBtnClick
            });
        break;
    case /* CaptureEmail */1 :
        tmp = JsxRuntime.jsx(SignUpForEmail.make, {
              onPreviousBtnClick: handlePreviousBtnClick,
              onNextBtnClick: handleNextBtnClick,
              stateEmail: state.email,
              stateFirstName: state.firstName,
              dispatch: dispatch
            });
        break;
    case /* CapturePassword */2 :
        tmp = JsxRuntime.jsx(SignUpForPassword.make, {
              onPreviousBtnClick: handlePreviousBtnClick,
              onNextBtnClick: handleNextBtnClick,
              statePassword: state.password,
              dispatch: dispatch,
              state: state
            });
        break;
    case /* CapturePhoneNumber */3 :
        tmp = JsxRuntime.jsx(SignUpForPhoneNumber.make, {
              onNextBtnClick: handleNextBtnClick,
              stateEmail: state.email,
              dispatch: dispatch
            });
        break;
    case /* ConfirmSecurityCode */4 :
        tmp = purchaseCallback !== undefined ? JsxRuntime.jsx(SignUpSecurityCode.make, {
                state: state,
                signupType: registrationFlowSignupType,
                purchaseCallback: purchaseCallback,
                segmentData: segmentData
              }) : JsxRuntime.jsx(SignUpSecurityCode.make, {
                state: state,
                signupType: registrationFlowSignupType,
                segmentData: segmentData
              });
        break;
    
  }
  return JsxRuntime.jsx(KontentContextProvider.make, {
              children: JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("h1", {
                                  children: Util.ReactStuff.s(title_),
                                  className: SignUpOnboardingStyles.title
                                }),
                            subtitle_ !== undefined ? JsxRuntime.jsx("h2", {
                                    children: Util.ReactStuff.s(subtitle_),
                                    className: SignUpOnboardingStyles.subtitle
                                  }) : null,
                            JsxRuntime.jsx(ProgressIndicator.make, {
                                  step: step
                                }),
                            tmp
                          ],
                          className: "pb-20"
                        })
                  }),
              itemId: match$2.itemId,
              elementCodename: match$2.codename
            });
}

var KontentContextConsumer;

var make = RegisterComponent;

export {
  KontentContextConsumer ,
  make ,
}
/* Util Not a pure module */
